<template>
	<div class="h-screen pt-6 flex flex-col bg-white">
		<Container class="w-full">
			<PageHeading :title="$t('pages.admin.companies.companies_admin_layout.admin_companies')"/>
		</Container>

		<TabLayout :tabs="tabs"/>

		<div class="flex-1 flex flex-col overflow-hidden">
			<router-view class="flex-1"></router-view>
		</div>

	</div>
</template>

<script>
import TabLayout from "@/Layouts/TabLayout.vue";
import PageHeading from "@/Components/PageHeading.vue";
import Container from "@/Components/Container.vue";

export default {
	name: "CompaniesAdminLayout",
	components: {Container, PageHeading, TabLayout},
	data() {
		return {}
	},
	computed: {
		tabs() {
			return [
				{
					label: this.$t('pages.admin.companies.companies_admin_layout.companies'),
					current: this.$route.name === 'admin.companies' || this.$route.name.startsWith('admin.companies.device'),
					to: {name: 'admin.companies'},
					permission: 'create:companies|update:companies',
				},
				{
					label: this.$t('pages.admin.companies.companies_admin_layout.company-relationships'),
					current: this.$route.name.startsWith('admin.companies.relationships'),
					to: {name: 'admin.companies.relationships'},
					permission: 'create:company-relationships|read:company-relationships',
				},
			].filter(t => t.permission === undefined || this.$auth.hasPermission(t.permission))
		}
	},
}
</script>

<style scoped>

</style>